<template>
  <v-app>
    <v-main class="ma-10">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>

<style>
  #app {
      background-color: whitesmoke;
  }
</style>
